import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { atomDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

const MarkdownRenderer = ({ content }) => {
  return (
    <div className="markdown-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
        code({ node, inline, className, children, ...props }) {
          const match = /language-(\w+)/.exec(className || '');
          return !inline && match ? (
            <SyntaxHighlighter
              style={atomDark}
              language={match[1]}
              PreTag="div"
              {...props}
            >
              {String(children).replace(/\n$/, '')}
            </SyntaxHighlighter>
          ) : (
            <code className="bg-[#2A2A2A] text-[#B4E50D] px-2 py-1 rounded text-sm" {...props}>
              {children}
            </code>
          );
        },
        table({ node, ...props }) {
          return (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-[#3A3A3A]" {...props} />
            </div>
          );
        },
        thead({ node, ...props }) {
          return <thead className="bg-[#1A1A1A]" {...props} />;
        },
        tr({ node, ...props }) {
          return <tr className="hover:bg-[#2A2A2A] transition-colors" {...props} />;
        },
        th({ node, ...props }) {
          return (
            <th
              className="px-4 py-2 text-left text-xs font-medium text-[#B4E50D] uppercase tracking-wider"
              {...props}
            />
          );
        },
        td({ node, ...props }) {
          return <td className="px-4 py-2 whitespace-nowrap text-sm text-[#FFFFFF]" {...props} />;
        },
        a({ node, ...props }) {
          return <a className="text-[#B4E50D] hover:text-[#B4E50D] hover:underline transition-colors" target="_blank" rel="noopener noreferrer" {...props} />;
        },
        p({ node, ...props }) {
          return <p className="mb-3 text-[#FFFFFF]" {...props} />;
        },
        ul({ node, ...props }) {
          return <ul className="list-disc pl-5 mb-3 text-[#FFFFFF]" {...props} />;
        },
        ol({ node, ...props }) {
          return <ol className="list-decimal pl-5 mb-3 text-[#FFFFFF]" {...props} />;
        },
        li({ node, ...props }) {
          return <li className="mb-2 text-[#FFFFFF]" {...props} />;
        },
        h1({ node, ...props }) {
          return <h1 className="text-xl font-bold mb-3 text-[#B4E50D]" {...props} />;
        },
        h2({ node, ...props }) {
          return <h2 className="text-lg font-bold mb-3 text-[#B4E50D]" {...props} />;
        },
        h3({ node, ...props }) {
          return <h3 className="text-md font-bold mb-3 text-[#B4E50D]" {...props} />;
        },
        blockquote({ node, ...props }) {
          return <blockquote className="border-l-4 border-[#B4E50D] pl-4 italic text-[#B0B0B0] bg-[#2A2A2A] py-2 rounded-r" {...props} />;
        },
        hr({ node, ...props }) {
          return <hr className="my-4 border-[#3A3A3A]" {...props} />;
        },
        strong({ node, ...props }) {
          return <strong className="font-semibold text-[#B4E50D]" {...props} />;
        },
        em({ node, ...props }) {
          return <em className="italic text-[#B0B0B0]" {...props} />;
        }
      }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
